/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Injectable } from '@angular/core';
import { IImportSystemsFacade } from '../../../../../data-access/src/lib/domain/facades-models/import-systems-facade-interface';
import { BackendService, LocalStorageService } from '../../../../../utils/src';
import { GlobalConstants } from '../../constants/global-constants';
import { SystemManagerExportReturnCodes } from '../../../../../../shared/ui/src/lib/enums/system-manager-export-return-codes';
import { Observable, from, take } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ImportSystemsFacade implements IImportSystemsFacade {
  constructor(
    public backendService: BackendService,
    private localStorageService: LocalStorageService
  ) {}

  public closeWindow(): void {
    this.backendService.onCloseWindow().pipe(take(1)).subscribe();
  }

  public windowResize(height: number, width: number): void {
    if (!!height && !!width) {
      this.backendService.changeDialogDimensions(height, width);
    }
  }

  public getAllImportSystems(filePath: string): Observable<string[]> {
    return from<Promise<string[]>>(
      this.backendService.messageHandler.sendRequestAsync(GlobalConstants.GetAllImportSystems, [filePath])
    );
  }

  public getSystemsFromConfiguration(): Observable<string[]> {
    return from<Promise<string[]>>(
      this.backendService.messageHandler.sendRequestAsync(GlobalConstants.GetSystemsFromConfiguration)
    );
  }

  public getLocalStorageForImportSystemsFile(): string {
    return this.localStorageService.getStorage(GlobalConstants.IMPORT_SYSTEMS_FILE);
  }

  public importSystemsLogic(
    importSystems: { [key: string]: string },
    filePath: string
  ): Observable<SystemManagerExportReturnCodes> {
    return from<Promise<SystemManagerExportReturnCodes>>(
      this.backendService.messageHandler.sendRequestAsync(GlobalConstants.ImportSystemsLogic, [importSystems, filePath])
    );
  }
}
